import React, { Fragment, useState, useEffect } from "react";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import {
  Breadcrumbs,
  Grid,
  Card,
  CardContent,
  Typography,
  Hidden,
} from "@material-ui/core";
import { withStyles, makeStyles, createStyles } from "@material-ui/core/styles";
import HomeStyles from "pages/HomeStyles";
import { setCurrentPage, getByAreaData } from "actions";
import * as C from "components";
import ByAreaSummary from "components/PicTree/Game/Area/ByAreaSummary";
import ByAreaDetailTable from "components/PicTree/Game/Area/ByAreaDetailTable";
import CalendarRangePicker from "components/Calendar/CalendarRangePicker";
import CalendarRangePicTreeNtt from "components/Calendar/CalendarRangePicTreeNtt";
import CalendarRangePicTreeNttFt from "components/Calendar/CalendarRangePicTreeNttFt";
import CalendarRangePicTreeHokuden from "components/Calendar/CalendarRangePicTreeHokuden";
import { useLocation } from "react-router-dom";

const useStyles = makeStyles((theme) =>
  createStyles({
    loaderBox: {
      width: "100%",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      minHeight: 280,
    },
    loaderBarImg: {
      width: 40,
    },
    breadcrumbs: {
      marginTop: 16,
      minHeight: 30,
    },
    gridSection: {
      marginTop: theme.spacing(1),
    },
    selectGameTxt: {
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      minHeight: 280,
      flexWrap: "wrap",
      "& > *": {
        margin: theme.spacing(0.5),
      },
    },
  })
);

const PicTreePhotoByArea = ({
  currentPage,
  setCurrentPage,
  pageTopLoader,
  dateRangePicTree,
  dateRangePicTreeNtt,
  dateRangePicTreeNttFt,
  dateRangePicTreeHokuden,
  getByAreaData,
  byAreaDataSummaryTepco,
  byAreaDataTableTepco,
  byAreaDataSummaryNtt,
  byAreaDataTableNtt,
  byAreaDataSummaryNttFt,
  byAreaDataTableNttFt,
  byAreaDataSummaryHokuden,
  byAreaDataTableHokuden,
}) => {
  const classes = useStyles();
  const location = useLocation();
  const [initialDataCall, setInitialDataCall] = useState(true);
  const [company, setCompany] = useState(null);
  const [summaryData, setSummaryData] = useState(null);
  const [tableData, setTableData] = useState(null);
  const [companyLbl, setCompanyLbl] = useState(null);

  useEffect(() => {
    setInitialDataCall(true);
    setCurrentPage(location.pathname);
    const seg = location.pathname.split("/");
    const nextCompany = seg[3] || null;
    setCompany(nextCompany);
    setSummaryData(null);
    setTableData(null);

    if (nextCompany === "ntt") {
      setCompanyLbl("NTT ME");
    } else if (nextCompany === "ntt-ft") {
      setCompanyLbl("NTT FT");
    } else {
      setCompanyLbl(nextCompany ? nextCompany.toUpperCase() : null);
    }
    getByAreaData(nextCompany);
  }, [location.pathname]);

  // useEffect(() => {
  //   if (
  //     dateRangePicTree[0] !== null &&
  //     dateRangePicTree[1] !== null &&
  //     company !== null &&
  //     initialDataCall
  //   ) {
  //     getByAreaData(company);
  //     setInitialDataCall(false);
  //   }
  // }, [dateRangePicTree]);

  // useEffect(() => {
  //   if (
  //     dateRangePicTreeNtt[0] !== null &&
  //     dateRangePicTreeNtt[1] !== null &&
  //     company !== null &&
  //     initialDataCall
  //   ) {
  //     getByAreaData(company);
  //     setInitialDataCall(false);
  //   }
  // }, [dateRangePicTreeNtt]);

  // useEffect(() => {
  //   if (
  //     dateRangePicTreeNttFt[0] !== null &&
  //     dateRangePicTreeNttFt[1] !== null &&
  //     company !== null &&
  //     initialDataCall
  //   ) {
  //     getByAreaData(company);
  //     setInitialDataCall(false);
  //   }
  // }, [dateRangePicTreeNttFt]);

  useEffect(() => {
    if (company === "tepco") {
      setSummaryData(byAreaDataSummaryTepco);
      setTableData(byAreaDataTableTepco);
    } else if (company === "ntt") {
      setSummaryData(byAreaDataSummaryNtt);
      setTableData(byAreaDataTableNtt);
    } else if (company === "ntt-ft") {
      setSummaryData(byAreaDataSummaryNttFt);
      setTableData(byAreaDataTableNttFt);
    } else if (company === "hokuden") {
      setSummaryData(byAreaDataSummaryHokuden);
      setTableData(byAreaDataTableHokuden);
    }
  }, [
    byAreaDataSummaryTepco,
    byAreaDataTableTepco,
    byAreaDataSummaryNtt,
    byAreaDataTableNtt,
    byAreaDataSummaryNttFt,
    byAreaDataTableNttFt,
    byAreaDataSummaryHokuden,
    byAreaDataTableHokuden,
  ]);

  return (
    <Fragment>
      <C.ContentWrapper>
        <Grid
          container
          spacing={0}
          direction="row"
          style={{ marginTop: -16, marginBottom: 8 }}
          justifyContent="space-between"
        >
          <Grid item>
            <Breadcrumbs separator="›" className={classes.breadcrumbs}>
              <Typography>PicTrée {companyLbl}</Typography>
              <Typography variant="body1">撮影</Typography>
              <Typography variant="body1">エリア別</Typography>
            </Breadcrumbs>
          </Grid>
          <Grid item className={classes.fillRemailSpace}></Grid>
          <Grid item>
            {company && (
              <>
                {company === "tepco" && (
                  <CalendarRangePicker mDate={"2024/04/13"} page="by-area" pictree />
                )}
                {company === "ntt" && (
                  <CalendarRangePicTreeNtt mDate={"2024/04/13"} page="pictree-ntt" pictree />
                )}
                {company === "ntt-ft" && (
                  <CalendarRangePicTreeNttFt mDate={"2024/04/13"} page="pictree-ntt" pictree />
                )}
                {company === "hokuden" && (
                  <CalendarRangePicTreeHokuden mDate={"2024/04/13"} page="pictree-hokuden" pictree />
                )}
              </>
            )}
          </Grid>
        </Grid>

        <Hidden smDown>
          <Grid
            container
            justifyContent="center"
            spacing={0}
            style={{ marginTop: 0 }}
          >
            <Grid item xs={12} md={12} lg={10}>
              <Card>
                <CardContent>
                  <div className={classes.cardContentSection}>
                    <ByAreaSummary data={summaryData} />
                  </div>
                </CardContent>
              </Card>
            </Grid>
          </Grid>
        </Hidden>

        <Grid
          container
          spacing={1}
          direction="row"
          style={{ marginTop: 16, marginRight: 16, marginBottom: 8 }}
          justifyContent="center"
        >
          <Grid
            item
            xs={12}
            md={12}
            lg={10}
            style={{ marginTop: 0, justifyContent: "center" }}
          >
            <ByAreaDetailTable data={tableData} />
          </Grid>
        </Grid>
      </C.ContentWrapper>
    </Fragment>
  );
};

PicTreePhotoByArea.propTypes = {
  classes: PropTypes.object,
};

const mapStateToProps = (state) => ({
  pageTopLoader: state.page.pageTopLoader,
  dateRangePicTree: state.page.dateRangePicTree,
  dateRangePicTreeNtt: state.page.dateRangePicTreeNtt,
  dateRangePicTreeNttFt: state.page.dateRangePicTreeNttFt,
  dateRangePicTreeHokuden: state.page.dateRangePicTreeHokuden,
  byAreaDataSummaryTepco: state.pictree.byAreaDataSummary,
  byAreaDataTableTepco: state.pictree.byAreaDataTable,
  byAreaDataSummaryNtt: state.pictreeNtt.byAreaDataSummary,
  byAreaDataTableNtt: state.pictreeNtt.byAreaDataTable,
  byAreaDataSummaryNttFt: state.pictreeNttFt.byAreaDataSummary,
  byAreaDataTableNttFt: state.pictreeNttFt.byAreaDataTable,
  byAreaDataSummaryHokuden: state.pictreeHokuden.byAreaDataSummary,
  byAreaDataTableHokuden: state.pictreeHokuden.byAreaDataTable,
});

const mapDispatchToProps = (dispatch) => ({
  setCurrentPage: (param) => dispatch(setCurrentPage(param)),
  getByAreaData: (param) => dispatch(getByAreaData(param)),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withStyles(HomeStyles, { withTheme: true })(PicTreePhotoByArea));
